import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { Tab } from "@material-ui/core";
import {
  TableWrapper,
  PlatformWrapper,
  PlatformTitleWrapper,
  StyledTabs,
  StyledPaper,
} from "./FuiStyles";
import { XSmallHeader } from "../common/CommonStyles/CommonTypographyStyles";
import OrderRequestsList from "./OrderRequestsList";
import DedicatedVpcRequestsList from "./DedicatedVpcRequestsList";

/**
 * Wrapper component for Order Requests with tabs
 * @author shilpa.adikeshava
 * @version 1.0
 */

const OrderRequestsTabWrapper = ({ data, history, onRefreshData }) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div style={{ height: "90%", marginTop: "2%", maxHeight: "90%" }}>
      <TableWrapper style={{ height: "100%" }}>
        <PlatformWrapper style={{ height: "10%", maxHeight: "10%", marginBottom: "15px" }}>
          <PlatformTitleWrapper>
            <XSmallHeader>Order Requests Status</XSmallHeader>
          </PlatformTitleWrapper>
        </PlatformWrapper>

        {/* Tabs for different order types */}
        <StyledTabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          <Tab label="App / Platform Orders" />
          <Tab label="Dedicated VPC Orders" />
        </StyledTabs>

        {/* Tab Content */}
        <div style={{ height: "450px", marginTop: "1%" }}>
          {activeTab === 0 && (
            <OrderRequestsList data={data} history={history} onRefreshData={onRefreshData} />
          )}
          {activeTab === 1 && (
            <DedicatedVpcRequestsList history={history} />
          )}
        </div>
      </TableWrapper>
    </div>
  );
};

OrderRequestsTabWrapper.propTypes = {
  /**
   * History property of route library
   */
  history: PropTypes.object,
  /**
   * Order requests data for App/Platform orders
   */
  data: PropTypes.array,
  /**
   * Callback function to refresh data
   */
  onRefreshData: PropTypes.func,
};

const MSTP = (state) => ({
  // No additional state needed from Redux for this wrapper
});

export default connect(MSTP)(withRouter(OrderRequestsTabWrapper));